<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_bc11" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
        <el-button @click="funcAdd">新增</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"  
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="partyGroupName" title="所属组织机构" min-width="200" sortable />
        <template v-slot:header>
          <partyGroupSelect ref="partyGroupSelect" style="width: 100%" @setPartyGroupCode="setPartyGroupCode" />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" title="部门名称" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入部门名称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="130">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="modelAddFlag" title="新增部门" width="500" height="300" resize>
      <compAdd ref="addRef" @fatherAddMethod="fatherAdd" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <vxe-modal v-model="modelEditFlag" title="编辑部门" width="500" height="300" resize>
      <compEdit ref="editRef" @fatherEditMethod="fatherEdit" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>

  </div>
</template>
<script>
import compAdd from './components/departmentAdd.vue'
import compEdit from './components/departmentEdit.vue'
// import compDetail from './components/departmentDetail.vue'
import partyGroupSelect from '@/views/components/partyGroupSelect.vue'
import request from '@/utils/request'
export default {
  name: 'DepartmentList',
  components: {
    compAdd,
    compEdit,
    // compDetail,
    partyGroupSelect
  },
  data() {
    return {
      message: '',
      loading: false,
      tableData: [],
      partyGroup: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      listQuery: {
        code: '',
        partyGroupCode: '',
        partyGroupName: '',
        name: '',
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
      Pagingconf: [],
    }
  },
  created() {
    this.getPartyGroup()
  },
  methods: {
    //获取机构信息
    getPartyGroup() {
      request({
        url: '/ntocc-basic-api/partyGroup/getPartyGroup',
        method: 'get'
      }).then(response => {
        this.partyGroup = response.data
        this.$refs.partyGroupSelect.initData(this.partyGroup, 'setPartyGroupCode')
      }).then(response => {
        this.findList()
      })
    },
    // 选择组织机构
    setPartyGroupCode(value) {
      this.listQuery.partyGroupCode = value
    },
    findList() {
      return new Promise(resolve => {
        this.loading = true
        request({
          url: '/ntocc-basic-api/department',
          method: 'get',
          params: this.listQuery
        }).then(response => {
          resolve();
          this.tableData = response.data.records
          this.listQuery.total = response.data.total
          response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.loading = false
        })
      })
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs.partyGroupSelect.initData(this.partyGroup, 'setPartyGroupCode')
      this.modelAddFlag = true
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.$refs.partyGroupSelect.initData(this.partyGroup, 'setPartyGroupCode')
      this.$refs.editRef.getInfo(code)
      this.modelEditFlag = true
    },

    // 删除方法
    funcDelete(row) {
      this.$confirm('确认删除吗？').then(_ => {
        request({ url: `/ntocc-basic-api/department`, method: 'delete', params: { codes: row }}).then(response => {
          this.$message({ message: response.msg, type: 'success' })
          this.findList()
        })
      }).catch(_ => {})
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false
      this.findList()
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false
      this.findList()
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case 'add':
          this.modelAddFlag = false
          break
        case 'edit':
          this.modelEditFlag = false
          break
        case 'detail':
          this.modelDetailFlag = false
          break
        default:
      }
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage
      this.listQuery.pageSize = pageSize
      this.findList()
    }
  }
}
</script>
